module.exports = __webpack_public_path__ + "static/alex-chat-0761a4edeb39685a0f5b4ffc043137e6.jpg";